export default __webpack_public_path__ + "./assets/background-tablet__952096be5f4ea9af038327f3baf78af5.jpg";